import { queryFor } from "@visioni/a3s-client-api/app";
import { accessManagementEndpoint } from "../client-messages/role-assignments";

export const accessManagementQuery = queryFor(accessManagementEndpoint);
